// iOS WebKit은 instant 점프 직후 한 프레임 sticky 크롬을 그리지 않는다 — smooth라야 안 깜빡인다.
export const scrollToPageTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};
